import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { useActivityNoteStyles } from '@/experiences/sales-portal/components/activity-notes/utils';
import { ViewStyle } from 'react-native';
import { YStack } from '@usepepper/sprout-kit-ui';

const SKELETON_CARD_COUNT = 3;
const CONTENT_BAR_HEIGHT = 14;
const CONTENT_BAR_WIDTH = '100%';
const CONTENT_BAR_SHORT_WIDTH = '70%';
const METADATA_BAR_HEIGHT = 12;
const METADATA_BAR_WIDTH = 160;
const CARD_FADE_STEP = 1 / (SKELETON_CARD_COUNT - 0.5);

const getCardFadeStyle = (index: number): ViewStyle => ({
  opacity: 1 - index * CARD_FADE_STEP,
});

export const ActivityNotesListSkeleton: React.FC = () => {
  const [styles, theme] = useActivityNoteStyles();

  const borderRadius = theme.sk.radii.radiusRound;

  return (
    <YStack style={styles.notesList}>
      {Array.from({ length: SKELETON_CARD_COUNT }, (_, index) => (
        <YStack key={index} style={[styles.card, getCardFadeStyle(index)]}>
          <AnimatedSkeletonLoader
            borderRadius={borderRadius}
            height={CONTENT_BAR_HEIGHT}
            width={CONTENT_BAR_WIDTH}
          />
          <AnimatedSkeletonLoader
            borderRadius={borderRadius}
            height={CONTENT_BAR_HEIGHT}
            width={CONTENT_BAR_SHORT_WIDTH}
          />
          <AnimatedSkeletonLoader
            borderRadius={borderRadius}
            height={METADATA_BAR_HEIGHT}
            width={METADATA_BAR_WIDTH}
          />
        </YStack>
      ))}
    </YStack>
  );
};
